import { defineComponent, ref, computed } from "vue";

export default defineComponent({
  name: "c-loading",

  props: {
    loading: { type: Boolean, default: false },
    style: { type: String, default: "" },
    class: { type: String, default: "" },
    sizes: { type: String, default: "width: 48px; height: 48px;" },
    textLoading: { type: String, default: "onboardProcessing" },
  },

  setup(props) {
    const className = ref(props.class);
    const styleName = ref(props.style);

    const isLoading = computed(() => {
      return props.loading;
    });

    return {
      className,
      styleName,
      isLoading,
    };
  },
});
